import "../../web/src/styles/fonts.css";
import "../../web/src/styles/tokens.css";
import "../../web/src/styles/base.css";
import "../../web/src/styles/components.css";
import "../../web/src/shell/shell.css";
import "../../web/src/auth/auth.css";
import "./admin.css";
import { render } from "preact";
import { startRouter } from "../../web/src/shell/router";
import { applyTheme, readTheme } from "../../web/src/shell/theme";
import { AdminApp } from "./AdminApp";

applyTheme(readTheme());
startRouter();

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root to render into.");
render(<AdminApp />, root);
